<template>
  <div class="text-primary primary-field">
    <div>
      {{ item.name }}
    </div>

    <i v-if="item.is_error" class="icon-fill_alert-circle" />
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
.primary-field {
  display: flex;
  justify-content: space-between;
  align-items: center;

  i {
    font-size: 16px;

    &:before {
      color: $red;
    }
  }
}
</style>
